import React from "react";
import PropTypes from "kf-proptypes/widgets";

import { BaseIcon, ICON_SERVICE } from "../index.jsx";

import styles from "./style.css";

export const ILLUSTRATION_SIZE = {
  BASE: "size-base",
  MEDIUM: "size-medium",
  SMALL: "size-small"
};

export function KfIllustration(props) {
  return (
    <BaseIcon
      service={ICON_SERVICE.ILLUSTRATION}
      className={`${props.className} ${styles.illustration}`}
      icon={props.icon}
      size={props.size}
      onClick={props.onClick}
      padding={props.padding}
    />
  );
}

KfIllustration.propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string,
  padding: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.string
};

KfIllustration.defaultProps = {
  onClick: () => {},
  size: ILLUSTRATION_SIZE.BASE
};
